import {
  UpdateIntegrationConfigurationResponseSchema,
  type UpdateIntegrationConfigurationRequestPayload,
  type UpdateIntegrationConfigurationResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useUpdateIntegrationConfiguration(
  options?: UseMutationOptions<
    UpdateIntegrationConfigurationResponse,
    unknown,
    UpdateIntegrationConfigurationRequestPayload
  >,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (updateIntegrationConfigurationRequest) => {
      const api = getPrivateApi();

      const updateIntegrationConfigurationResponse = await api.updateIntegrationConfiguration({
        updateIntegrationConfigurationRequest,
      });

      return UpdateIntegrationConfigurationResponseSchema.parse(updateIntegrationConfigurationResponse);
    },
    {
      onSuccess: async () => queryClient.invalidateQueries(queryKeys.integration()),
      ...options,
    },
  );
}
